const messages = {
  it: {
    custom: {
      profession: {
        required: 'Il campo professione è obbligatorio.'
      },
      name: {
        required: 'Il campo nome è obbligatorio.'
      },
      surname: {
        required: 'Il campo cognome è obbligatorio.'
      },
      city: {
        required: 'Il campo città è obbligatorio.'
      },
      email: {
        required: 'Il campo email è obbligatorio.',
        email: 'Il campo email deve contenere una email valida.'
      },
      telephone: {
        required: 'Il campo telefono è obbligatorio.'
      },
      message: {
        required: 'Il campo messaggio è obbligatorio.'
      },
      privacy: {
        required: 'Devi aver letto e accettato le condizioni sulla tutela della privacy.'
      }
    }
  },
  en: {
    custom: {
      profession: {
        required: 'The profession field is required.'
      },
      name: {
        required: 'The name field is required.'
      },
      surname: {
        required: 'The surname field is required.'
      },
      city: {
        required: 'The city field is required.'
      },
      email: {
        required: 'The email field is required.',
        email: 'The email field must be a valid email.'
      },
      telephone: {
        required: 'The telephone field is required.'
      },
      message: {
        required: 'The message field is required.'
      },
      privacy: {
        required: 'You must accept the therms of the privacy policy.'
      }
    }
  }
}

export default messages
